module.exports = __webpack_public_path__ + "img/dlykdxfsde.f7b0dc38.png";